import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
// Newly added code starts
import Hidden from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
// Newly added code ends
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    // Existing widget old code
    // logoGridItem?: GridItemProps;
    linkList1GridItem?: GridItemProps;
    linkList2GridItem?: GridItemProps;
    linkList3GridItem?: GridItemProps;
    linkList4GridItem?: GridItemProps;
    linkList5GridItem?: GridItemProps;
    contactUsGridItem?: GridItemProps;
    announcementGridItem?: GridItemProps;
    footerLinks?: InjectableCss;
    subscribeGridItem?: GridItemProps;
    seperatorGridItem?: GridItemProps;
    mobileSeperatorGridItem?: GridItemProps;
    desktopSeperatorGridItem?: GridItemProps;
    sitemapGridItem?: GridItemProps;
    socialLinksGridItem?: GridItemProps;
    siteMapLinksGridItem?: GridItemProps;
    richContentGridItem?: GridItemProps;
    logoWrapper?: InjectableCss;
}

export const footerContainerStyles: FooterContainerStyles = {
    // Existing widget old code
    // logoGridItem: {
    //     width: 12,
    //     css: css`
    //         width: 100%;
    //         display: flex;
    //         justify-content: center;
    //         img {
    //             height: 78px;
    //         }
    //     `,
    // },
    
    linkList1GridItem: {
        width: [0, 0, 4, 2, 2],
        css: css`
            padding-top: 0;
            padding-bottom: 0;
            > div > div > div:first-child {
                padding-bottom: 24px;
            }
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        flex-basis: 19%;
                        max-width: 19%;
                    `,
                    css`
                        flex-basis: 19%;
                        max-width: 19%;
                    `,      
                ]
            )};
        `,
    },
    linkList2GridItem: {
        width: [0, 0, 4, 2, 2],
        css: css`
        padding-top: 0;
            padding-bottom: 0;
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        flex-basis: 24%;
                        max-width: 24%;
                    `,
                    css`
                        flex-basis: 24%;
                        max-width: 24%;
                    `,       
                ]
            )};
        `,
    },
    linkList3GridItem: {
        width: [0, 0, 4, 2, 2],
        css: css`
        padding-top: 0;
            padding-bottom: 0;
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        flex-basis: 13%;
                        max-width: 13%;
                    `,
                    css`
                        flex-basis: 13%;
                        max-width: 13%;
                    `,      
                ]
            )};
        `,
    },
    linkList4GridItem: {
        width: [0, 0, 4, 2, 2],
        css: css`
        padding-top: 0;
            padding-bottom: 0;
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        padding-top: 24px;
                    `,
                    css`
                        flex-basis: 25%;
                        max-width: 25%;
                    `,
                    css`
                        flex-basis: 25%;
                        max-width: 25%;
                    `,       
                ]
            )};
        `,
    },
    linkList5GridItem: {
        width: [0, 0, 4, 2, 2],
        css: css`
        padding-top: 0;
            padding-bottom: 0;
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        padding-top: 24px;
                    `,
                    css`
                        flex-basis: 19%;
                        max-width: 19%;
                    `,
                    css`
                        flex-basis: 19%;
                        max-width: 19%;
                    `,      
                ]
            )};
        `,
    },
    announcementGridItem: {
        width: [12, 12, 2, 2, 2],
        css: css`
        padding-top: 0;
            > div {
                width: 100%;
            }
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 70%;
                        max-width: 70%;
                    `,
                    css`
                    flex-basis: 80%;
                    max-width: 80%;
                    `,
                    css`
                        flex-basis: 80%;
                        max-width: 80%;
                    `,      
                ]
            )};
        `,
    },
    desktopSeperatorGridItem: {
        width: [0, 0, 12, 12, 12],
        css: css`
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        `,
    },
    mobileSeperatorGridItem: {
        width: [12, 12, 0, 0, 0],
        css: css`
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        `,
    },
    contactUsGridItem: {
        width: [12, 12, 2, 2, 2],
        css: css`
        padding-top: 0;
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 30%;
                        max-width: 30%;
                    `,
                    css`
                    flex-basis: 20%;
                    max-width: 20%;
                    `,
                    css`
                        flex-basis: 20%;
                        max-width: 20%;
                    `,      
                ]
            )};
        `,
    },
    footerLinks: {
        css: css`
            font-size: ${TYPOGRAPHY.size.smaller};
            .list-wrapper {
                text-transform: capitalize;
                padding: 0;
                span {
                    color: ${COLORS.black};
                    padding-bottom: 8px;
                }
                > .links-wrapper:last-child span {
                    padding-bottom: 0;
                }
                .list-link span {
                    line-height: 24px;
                }
                .title-wrapper {
                    font-weight: ${TYPOGRAPHY.weight.mediumbold};
                }
                .title-wrapper span {
                    line-height: 16px;
                }
            }
        `,
    },
    subscribeGridItem: {
        width: [12, 12, 12, 8, 8],
        css: css`
            align-items: center !important;
            padding-bottom: 3px;
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    padding-bottom: 32px;
                    `,
                    css`
                    padding-bottom: 32px;
                    `,
                    null,     
                ]
            )};
        `,
    },
    seperatorGridItem: {
        width: 12,
        css: css`
            padding-top: 0 !important;
            padding-bottom: 0 !important;
        `,
    },
    sitemapGridItem: {
        width: [12, 12, 12, 4, 4],
        css: css`
            align-items: center;
            padding-bottom: 0;
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    padding-top: 0;
                    padding-bottom: 0;
                    `,
                    css`
                    padding-top: 0;
                    padding-bottom: 0;
                    `,
                    null,     
                ]
            )};
        `,
    },
    socialLinksGridItem: {
        width: 12,
    },
    siteMapLinksGridItem: {
        width: 12,
    },
    richContentGridItem: {
        width: 12,
    },
    logoWrapper: {
        css: css`
            width: 110px;
        `,
    },
};

const FooterContainer: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));
    return (
        <GridContainer {...styles.widgetGridContainer}>
            {/* Existing widget old code  */}
            {/* <GridItem {...styles.logoGridItem}>
                <StyledWrapper {...styles.logoWrapper}>
                    <Zone zoneName="Logo" contentId={id} />
                </StyledWrapper>
            </GridItem> */}
            <GridItem {...styles.subscribeGridItem}>
                <Zone zoneName="Subscribe" contentId={id} />
            </GridItem>
            <GridItem {...styles.sitemapGridItem}>
                <Zone zoneName="Sitemap" contentId={id} />
            </GridItem>
            <GridItem {...styles.seperatorGridItem}>
                <Zone zoneName="Seperator" contentId={id} />
            </GridItem>
            <GridItem {...styles.linkList1GridItem}>
                <StyledWrapper {...styles.footerLinks}>
                    <Zone zoneName="LinkList1" contentId={id} />
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.linkList2GridItem}>
            <StyledWrapper {...styles.footerLinks}>
            <Zone zoneName="LinkList2" contentId={id} />
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.linkList3GridItem}>
            <StyledWrapper {...styles.footerLinks}>
            <Zone zoneName="LinkList3" contentId={id} />
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.linkList4GridItem}>
            <StyledWrapper {...styles.footerLinks}>
            <Zone zoneName="LinkList4" contentId={id} />
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.linkList5GridItem}>
            <StyledWrapper {...styles.footerLinks}>
            <Zone zoneName="LinkList5" contentId={id} />
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.desktopSeperatorGridItem}>
                <Zone zoneName="Seperator" contentId={id} />
            </GridItem>
            <GridItem {...styles.announcementGridItem}>
                <StyledWrapper>
                    <Zone zoneName="Announcement" contentId={id} />
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.mobileSeperatorGridItem}>
                <Zone zoneName="Seperator" contentId={id} />
            </GridItem>
            <GridItem {...styles.contactUsGridItem}>
                <StyledWrapper>
                    <Zone zoneName="ContactUs" contentId={id} />
                </StyledWrapper>
            </GridItem>
            {/* <GridItem {...styles.socialLinksGridItem}>
                <Zone zoneName="SocialLinks" contentId={id} />
            </GridItem>
            <GridItem {...styles.siteMapLinksGridItem}>
                <Zone zoneName="SiteMapLinks" contentId={id} />
            </GridItem>
            <GridItem {...styles.richContentGridItem}>
                <Zone zoneName="RichContent" contentId={id} />
            </GridItem> */}
        </GridContainer>
    );
};

const footerContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],
    },
};

export default footerContainer;
